import { FC } from 'react';

import { LANGUAGES } from '@savgroup-front-common/constants';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { cn } from '@savgroup-front-common/primitive/lib/utils';
import {
  Item,
  ItemContent,
  ItemMedia,
  ItemTitle,
} from '@savgroup-front-common/primitive/ui/item';
import {
  RadioGroup,
  RadioGroupItem,
} from '@savgroup-front-common/primitive/ui/radio-group';

import { useProfileActions } from '../hooks/useProfileActions';
import { useProfileData } from '../hooks/useProfileData';

import messages from './messages';

interface NavigationDrawerLanguageListProps {
  onSelect: () => void;
}

export const NavigationDrawerLanguageList: FC<
  NavigationDrawerLanguageListProps
> = ({ onSelect }) => {
  const { languages, locale } = useProfileData();
  const { updateIntl } = useProfileActions();

  return (
    <RadioGroup
      value={locale}
      onValueChange={(value) => {
        updateIntl(value as LANGUAGES);
        onSelect();
      }}
      className="w-full gap-1"
      data-testid="appBar_drawerLanguageList"
    >
      {(languages ?? []).map((language) => {
        const upperLanguage = language.toUpperCase() as keyof typeof LANGUAGES;
        const key = LANGUAGES[upperLanguage];
        const radioId = `navigationDrawerLanguageList_radio_${key}`;

        return (
          <Item
            key={key}
            asChild
            variant="outline"
            size="sm"
            className={cn(
              'cursor-pointer hover:border-border-base-hover hover:bg-surface-base-hover',
              'has-data-checked:border-border-primary-default has-data-checked:bg-surface-base-active',
            )}
          >
            <label htmlFor={radioId}>
              <ItemMedia>
                <RadioGroupItem id={radioId} value={key} />
              </ItemMedia>
              <ItemContent>
                <ItemTitle className="text-base font-normal">
                  <SafeFormattedMessageWithoutSpread message={messages[language]} />
                </ItemTitle>
              </ItemContent>
            </label>
          </Item>
        );
      })}
    </RadioGroup>
  );
};
